import React, { useState, useEffect } from 'react'

// Deterministic colour per user so the same person always renders the same
// avatar in the fallback state (looks more like an identity, less like a bug).
const PALETTE = [
  'bg-blue-500', 'bg-emerald-500', 'bg-purple-500', 'bg-pink-500',
  'bg-amber-500', 'bg-teal-500', 'bg-rose-500', 'bg-indigo-500'
]

const colorFor = (seed) => {
  if (!seed) return PALETTE[0]
  let hash = 0
  for (let i = 0; i < seed.length; i++) {
    hash = (hash * 31 + seed.charCodeAt(i)) | 0
  }
  return PALETTE[Math.abs(hash) % PALETTE.length]
}

const initialsFor = (name, email) => {
  const source = (name && name.trim()) || (email && email.split('@')[0]) || '?'
  const parts = source.split(/\s+/).filter(Boolean)
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase()
  return source.slice(0, 2).toUpperCase()
}

const UserAvatar = ({
  name,
  email,
  avatarUrl,
  className = 'h-8 w-8',
  textClassName = 'text-xs'
}) => {
  const [failed, setFailed] = useState(false)

  // Reset error state when the URL changes — prevents a stuck fallback after
  // an admin edits the user and a new avatar is loaded.
  useEffect(() => {
    setFailed(false)
  }, [avatarUrl])

  const showImage = !!avatarUrl && !failed

  if (showImage) {
    return (
      <img
        src={avatarUrl}
        alt={name || email || 'User'}
        className={`${className} rounded-full object-cover bg-gray-100`}
        onError={() => setFailed(true)}
        referrerPolicy="no-referrer"
      />
    )
  }

  return (
    <div
      className={`${className} rounded-full flex items-center justify-center text-white font-semibold ${colorFor(email || name)} ${textClassName}`}
      aria-label={name || email || 'User'}
    >
      {initialsFor(name, email)}
    </div>
  )
}

export default UserAvatar
